module.exports = __webpack_public_path__ + "cd70f75ba72e6a7466a3508599084195.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.resource/font/iconfont.woff2?t=1732508423204
// module id = 350
// module chunks = 0